/* eslint-env browser, node */
function isAxiosLike(instance) {
  return Boolean(
    instance &&
      typeof instance === "function" &&
      instance.defaults &&
      instance.interceptors &&
      instance.interceptors.request &&
      typeof instance.interceptors.request.use === "function" &&
      instance.interceptors.response &&
      typeof instance.interceptors.response.use === "function"
  );
}

function loadAxiosCoreModule() {
  // Primary path: webpack alias defined in vue.config.js
  try {
    return require("axios-core");
  } catch {
    // Fallback for environments where alias is not active (e.g. direct node execution)
    try {
      return require("../../node_modules/axios");
    } catch {
      return null;
    }
  }
}

function resolveAxiosInstance() {
  const axiosModule = loadAxiosCoreModule();
  if (!axiosModule) return null;

  const candidates = [
    axiosModule,
    axiosModule && axiosModule.default,
    axiosModule && axiosModule.axios,
  ];
  for (const candidate of candidates) {
    if (isAxiosLike(candidate)) return candidate;
  }
  return null;
}

const axios = resolveAxiosInstance();

function normalizeApiUrl(url) {
  if (typeof url !== "string") return url;
  return url.replace(/\.php\/(?=$|\?)/g, ".php").replace(/\/\?(?=[^#])/g, "?");
}

function applyFetchDefaults() {
  const g =
    typeof window !== "undefined"
      ? window
      : typeof self !== "undefined"
      ? self
      : typeof global !== "undefined"
      ? global
      : null;
  if (!g || typeof g.fetch !== "function") return;
  if (g.__haFetchDefaultsApplied) return;

  const originalFetch = g.fetch.bind(g);
  g.__haFetchDefaultsApplied = true;

  g.fetch = (input, init) => {
    const normalizedInput =
      typeof input === "string" ? normalizeApiUrl(input) : input;
    const mergedInit =
      init && typeof init === "object"
        ? { ...init, credentials: "include" }
        : { credentials: "include" };

    return originalFetch(normalizedInput, mergedInit);
  };
}

if (!axios) {
  console.warn(
    "[axiosDefaults] Failed to load a valid axios instance. Applying fetch defaults only."
  );
  applyFetchDefaults();
} else if (!axios.__haDefaultsApplied) {
  axios.__haDefaultsApplied = true;

  // Ensure cookies/session are sent with every axios request by default.
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use((config) => ({
    ...config,
    url: normalizeApiUrl(config.url),
    withCredentials: true,
  }));

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 404) {
        const method = String(error?.config?.method || "get").toUpperCase();
        const url = error?.config?.url || "(unknown URL)";
        console.error(`[HTTP 404] ${method} ${url}`);
      }
      return Promise.reject(error);
    }
  );

  // Ensure cookies/session are sent with fetch requests by default.
  applyFetchDefaults();
}

const exported = axios || {};
module.exports = exported;
module.exports.default = exported;
module.exports.normalizeApiUrl = normalizeApiUrl;
